// @flow

import { handleWarning } from '@tectonics/alert-handler';

export async function watchSubmitTimeout(callback: () => Promise<*>, timeout: number = 60000): Promise<*> {
  const timeoutId = setTimeout(() => {
    handleWarning(new Error('ABW: Submit took more than limit time'));
  }, timeout);

  try {
    return await callback();
  } finally {
    clearTimeout(timeoutId);
  }
}
